import {useAppSelector} from "@Hooks/selector/useAppSelector";
import PassengerClassesNoLongerAvailableDataType
    from "@CheckOrder/features/modals/types/PassengerClassesNoLongerAvailableData.type";

export default function usePassengerClassesNoLongerAvailableModal() {
    const {modalNotice} = useAppSelector((state) => (state.checkOrder))

    if (!modalNotice || modalNotice.name !== "passengerClassNoLongerAvailable") {
        return {
            noLongerAvailableClasses: [],
            affectedPassengerIdsPerClass: {},
        }
    }

    const {
        data: {
            noLongerAvailableClasses,
            affectedPassengerIdsPerClass,
        },
    } = modalNotice as { data: PassengerClassesNoLongerAvailableDataType }

    return {
        noLongerAvailableClasses,
        affectedPassengerIdsPerClass,
    }
}